module.exports = __webpack_public_path__ + "static/media/public3.d773e846.png";